@if (mediaItem) {
  <div class="bg-gray-100">
    @if (previewImage) {
      <div class="thumb">
        <img
          class="product-image product-image-ratio"
          [src]="mediaItem.previewImage.url"
          [alt]="alt || mediaItem.previewImage.altText || mediaItem.alt || fallbackAlt"
          [class.object-fit-cover]="mediaItem.mediaContentType.toLowerCase() === 'video'"
          [srcset]="srcSetAttr"
          [sizes]="sizesAttr"
          loading="lazy"
          width="600"
          height="750"
          />
        @if (mediaItem.mediaContentType.toLowerCase() === 'video') {
          <app-icon class="thumb__icon-overlay" [anchor]="'icon-play'"></app-icon>
        }
      </div>
    } @else {
      @switch (mediaItem.mediaContentType) {
        <!--<div *ngSwitchCase="'EXTERNALVIDEO'"></div>-->
        <!--<div *ngSwitchCase="'MODEL3D'"></div>-->
        @case ('VIDEO') {
          @if (mediaItem?.sources?.[0]?.url) {
            <fstr-html5-video
              class="product-video-ratio"
              [src]="mediaItem!.sources![0]!.url"
              [playsinline]="true"
              (ready)="videoReady($event)"
              [playerVars]="playerVars"
            ></fstr-html5-video>
          }
        }
        @default {
          <img
            [ngClass]="productImage ? 'product-image product-image-ratio' : ''"
            [src]="mediaItem.previewImage.url"
            [alt]="alt || mediaItem.previewImage.altText || mediaItem.alt || fallbackAlt"
            [srcset]="srcSetAttr"
            [sizes]="sizesAttr"
            loading="lazy"
            width="600"
            height="750"
            />
        }
      }
    }
  </div>
}
